/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.css'
import React, { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import moment from 'moment'
import { getFormattedDate } from 'utils'

import { useSelector } from 'react-redux'
import I18n from 'i18next';


const VaultSummary = () => {
  const items = [
    {
      key: 'TotalNoofAlerts',
      label: I18n.t('Total number of Alerts'),
      defaultValue: 15
    },
    {
      key: 'NoofComplianceAlerts',
      label: I18n.t('Number of Compliance Alerts'),
      defaultValue: 5
    },
    {
      key: 'NoofMonitoringAlerts',
      label: I18n.t('Number of Monitoring Alerts'),
      defaultValue: 10
    },
    {
      key: 'NoofBusinesseswithChanges',
      label: I18n.t('Number of Businesses with Changes'),
      defaultValue: 2167
    },
  ]
  const vaultInfo = useSelector(state => state.apiResponseReducers.dashboardInfo?.vault_info)
  const [displayVaultSummary, setDisplayVaultSummary] = useState({})

  useEffect(() => {
    if (vaultInfo) {
      let formattedSummary = {
        lastAccessed: vaultInfo.last_accesed
          ? moment(vaultInfo.last_accesed).format('MM/DD/YYYY, hh:mm:ss A')
          : 'No data',
        lastShareActivity: vaultInfo.last_share_activity
          ? moment(vaultInfo.last_share_activity).format('MM/DD/YYYY, hh:mm:ss A')
          : 'No data',
        lastDocumentAddedDate: vaultInfo.last_document_added_date
          ? moment(vaultInfo.last_document_added_date).format('MM/DD/YYYY, hh:mm:ss A')
          : 'No data',
        numberOfDocumentsInVault: vaultInfo.document_count || 0,
        numberOfBeneficiaryOwners: vaultInfo.owner_count || 0,
      }

      if (vaultInfo.vault_article_count_by_category && vaultInfo.vault_article_count_by_category.length) {
        const countsPerCategory = {}
        vaultInfo.vault_article_count_by_category.forEach(e => {
          if (e.article_category === 'Beneficial Owners') return
          countsPerCategory[e.article_category] = e.article_count
        })

        formattedSummary.countsPerCategory = countsPerCategory
      }
      setDisplayVaultSummary(formattedSummary)
    } else {
      setDisplayVaultSummary({
        //TODO: Changed for Demo
        lastAccessed: getFormattedDate(new Date(), 'mm/dd/yyyy'),
        //TODO: Changed for Demo
        lastShareActivity: 'no data',
        //TODO: Changed for Demo
        lastDocumentAddedDate: 'no data',
        //TODO: Changed for Demo
        numberOfDocumentsInVault: 0,
        //TODO: Changed for Demo
        numberOfBeneficiaryOwners: 0,
      })
    }
  }, [vaultInfo])

  return (
    <Box
      sx={{
        height: '200px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
        textAlign: 'left',
      }}
    >
      {items.map(item => (
        <Box key={item.key} sx={{ float: 'left', marginY: 0.5 }}>
          <Typography component={'span'} variant={'body2B'} color={'primary'} id={item.key}>
            {item.label}:&nbsp;
          </Typography>
          <Typography component={'label'} variant={'body2'} color={'primary'} htmlFor={item.key}>
            {item.defaultValue}
          </Typography>
        </Box>
      ))}

      {displayVaultSummary.countsPerCategory &&
        Object.keys(displayVaultSummary.countsPerCategory).map((key, index) => (
          <Box sx={{ float: 'left', marginY: 0.5 }} key={key}>
            <Typography component={'span'} variant={'body2B'} color={'primary'} id={key}>
              {key}:&nbsp;
            </Typography>
            <Typography component={'label'} variant={'body2'} color={'primary'} htmlFor={key}>
              {displayVaultSummary.countsPerCategory[key]}
            </Typography>
          </Box>
        ))}
    </Box>
  )
}

export default VaultSummary
